import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import React, { useMemo } from 'react';
import { Images } from '@/assets/images';
import { useContent } from '@/provider/ContentProvider';

const Footer: React.FC = () => {
  const theme = useTheme();

  const {
    content: {
      footer: { twitterURL, facebookURL, instagramURL, youtubeURL, contactUsURL, linkedInURL, discordURL, farcasterURL }
    }
  } = useContent();

  const linkStyle = useMemo(
    () => ({
      textDecoration: 'none',
      fontFamily: theme?.MojitoClaim?.font?.secondary,
      color: theme?.palette?.text?.primary
    }),
    [theme]
  );

  return (
    <Box
      sx={{
        ...theme?.ClaimTemplate?.Footer,
        background: theme?.palette?.background?.paper,
        width: '100%',
        marginTop: '-2rem'
      }}
    >
      <Grid
        container
        sx={{
          padding: '21px 28px'
        }}
      >
        <Grid item lg={6} md={6} sm={9} xs={12}>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: {
                lg: 'row',
                md: 'row',
                sm: 'row',
                xs: 'column'
              },
              gap: '10px',
              alignItems: {
                lg: 'flex-end',
                md: 'flex-end',
                sm: 'flex-end',
                xs: 'flex-start'
              },
              height: '100%'
            }}
            direction={{
              lg: 'row',
              md: 'row',
              sm: 'row',
              xs: 'column'
            }}
            spacing={{
              lg: 3,
              md: 3,
              sm: 3,
              xs: 1
            }}
          >
            <a rel="noreferrer" href="/terms-and-conditions" target="_blank" style={linkStyle}>
              Terms & Conditions
            </a>
            <a rel="noreferrer" href="/privacy-policy" target="_blank" style={linkStyle}>
              Privacy Policy
            </a>
            {contactUsURL && (
              <a rel="noreferrer" href={contactUsURL} target="_blank" style={linkStyle}>
                Contact Us
              </a>
            )}
          </Stack>
        </Grid>
        <Grid
          sx={{
            display: {
              lg: 'flex',
              md: 'flex',
              sm: 'none',
              xs: 'none'
            }
          }}
          item
          lg={3}
          md={3}
          sm={3}
          xs={12}
        >
          <Image
            style={{
              marginBottom: '3rem'
            }}
            src={Images.KINETEK_LOGO}
            alt="logo"
            height={50}
            width={50}
          />
        </Grid>
        <Grid
          item
          lg={3}
          md={3}
          sm={3}
          xs={12}
          sx={{
            display: 'flex',
            paddingTop: {
              lg: 0,
              md: 0,
              sm: 0,
              xs: '24px'
            },
            justifyContent: {
              lg: 'flex-end',
              md: 'flex-end',
              sm: 'flex-end',
              xs: 'flex-start'
            }
          }}
        >
          <Stack
            sx={{
              display: 'flex',
              alignItems: 'end',
              height: '100%'
            }}
            direction="row"
            spacing={3}
          >
            {instagramURL && (
              <a href={instagramURL} target="_blank" rel="noreferrer">
                <InstagramIcon
                  sx={{
                    color: theme?.palette?.text?.primary
                  }}
                />
              </a>
            )}
            {twitterURL && (
              <a rel="noreferrer" href={twitterURL} target="_blank">
                <TwitterIcon
                  sx={{
                    color: theme?.palette?.text?.primary
                  }}
                />
              </a>
            )}
            {facebookURL && (
              <a href={facebookURL} target="_blank" rel="noreferrer">
                <FacebookIcon
                  sx={{
                    color: theme?.palette?.text?.primary
                  }}
                />
              </a>
            )}
            {youtubeURL && (
              <a href={youtubeURL} target="_blank" rel="noreferrer">
                <YouTubeIcon
                  sx={{
                    color: theme?.palette?.text?.primary
                  }}
                />
              </a>
            )}
            {linkedInURL && (
              <a href={linkedInURL} target="_blank" rel="noreferrer">
                <Box marginTop="3px">
                  <LinkedInIcon
                    sx={{
                      color: theme?.palette?.text?.primary
                    }}
                  />
                </Box>
              </a>
            )}
            {discordURL && (
              <a href={discordURL} target="_blank" rel="noreferrer">
                <Box marginTop="3px">
                  <Image
                    src={Images.DISCORD.default.src}
                    width={22}
                    height={22}
                    style={{
                      width: '22px',
                      height: '22px'
                    }}
                    alt="discord"
                  />
                </Box>
              </a>
            )}
            {farcasterURL && (
              <a href={farcasterURL} target="_blank" rel="noreferrer">
                <Box marginTop="3px">
                  <Image
                    width={22}
                    height={22}
                    src="https://nxt.mercedes-benz.com/cdn/ff/8EeLkBBYHAMo8nomZtAeERez_L0H34eFfU7xzQz2MOg/1684753586/public/2023-05/Vector.png"
                    style={{
                      width: '22px',
                      height: '22px'
                    }}
                    alt="farcaster"
                  />
                </Box>
              </a>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
